import { render, staticRenderFns } from "./addAddress.vue?vue&type=template&id=c92c7406&scoped=true&"
import script from "./addAddress.vue?vue&type=script&lang=js&"
export * from "./addAddress.vue?vue&type=script&lang=js&"
import style0 from "./addAddress.vue?vue&type=style&index=0&id=c92c7406&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92c7406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c92c7406')) {
      api.createRecord('c92c7406', component.options)
    } else {
      api.reload('c92c7406', component.options)
    }
    module.hot.accept("./addAddress.vue?vue&type=template&id=c92c7406&scoped=true&", function () {
      api.rerender('c92c7406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/address/addAddress.vue"
export default component.exports